// extracted by mini-css-extract-plugin
module.exports = {"CurrentStaffCourse":"InputBookingTargetWithStaff_CurrentStaffCourse__rQG2f","CurrentStaffCourse__Menu":"InputBookingTargetWithStaff_CurrentStaffCourse__Menu__qQQvg"};